import { Row, Table, Tooltip } from "antd";
import { useSelector } from "react-redux";
import { statisticsSelector } from "../../../services/selector/index.";
import { IconNext, IconPre, IconSpin } from "../../../assets/icon";
import "../../../assets/style/table/statistics.scss";
import { useMemo } from "react";
import dayjs from "dayjs";

const TableStatisticChat = ({ config, setConfig, type }) => {
  const statisticsState = useSelector(statisticsSelector);
  const { dataSatisticsMessage } = statisticsState;
  const { content, totalElements } = dataSatisticsMessage;

  const dataSourceChatUp = useMemo(() => {
    if (!content) {
      return;
    }
    const result = content?.map((item, index) => {
      const timeLabel = `${dayjs(item.timeStart).format("DD/MM/YY")} - ${dayjs(
        item.timeEnd
      ).format("DD/MM/YY")}`;
      return {
        ...item,
        STT: config.page * config.size + index + 1,
        key: item.id,
        timeCreate: item.weekNumber ? (
          <>
            Tuần {item.weekNumber + 1}
            <br />({timeLabel})
          </>
        ) : (
          <>
            Tháng {item.monthNumber}
            <br />({timeLabel})
          </>
        ),
      };
    });
    return result;
  }, [content]);

  const columnTotalChat = [
    {
      title: "STT",
      dataIndex: "STT",
      key: "STT",
      className: "centerCell",
      width: 90,
    },
    {
      title: "Thời gian",
      dataIndex: "timeCreate",
      key: "timeCreate",
      className: "centerCell",
      ellipsis: { showTitle: false },
    },
    {
      title: "Tổng phiên chat",
      key: "totalSession",
      className: "centerCell",
      // width: "15%",
      ellipsis: { showTitle: false },
      render: (_, record) => {
        return record.customerMessageCount + record?.agentMessageCount;
      },
    },
    {
      title: "KH chủ động chat lên",
      dataIndex: "customerMessageCount",
      key: "customerMessageCount",
      className: "centerCell",
      // width: "15%",
      ellipsis: { showTitle: false },
    },
    {
      title: "NV chủ động chat xuống",
      dataIndex: "agentMessageCount",
      key: "agentMessageCount",
      className: "centerCell",
      // width: "15%",
      ellipsis: { showTitle: false },
    },
  ];

  const columnsChatUp = [
    {
      title: "STT",
      dataIndex: "STT",
      key: "STT",
      className: "centerCell",
      width: 90,
    },
    {
      title: "Thời gian",
      dataIndex: "timeCreate",
      key: "timeCreate",
      className: "centerCell",
      ellipsis: { showTitle: false },
    },
    {
      title: "KH chủ động chat lên",
      dataIndex: "customerMessageCount",
      key: "customerMessageCount",
      className: "centerCell",
      width: "15%",
      ellipsis: { showTitle: false },
    },

    {
      title: "NV đã trả lời",
      dataIndex: "agentMessageRespondedCount",
      key: "agentMessageRespondedCount",
      className: "centerCell",
      ellipsis: { showTitle: false },
    },
    {
      title: "NV đã đọc",
      dataIndex: "agentMessageReadNotRespondedCount",
      key: "agentMessageReadNotRespondedCount",
      className: "centerCell",
      ellipsis: { showTitle: false },
    },
    {
      title: "NV chưa đọc",
      dataIndex: "agentMessageUnreadCount",
      key: "agentMessageUnreadCount",
      className: "centerCell",
      ellipsis: { showTitle: false },
    },
  ];
  //
  const columnsChatDown = [
    {
      title: "STT",
      dataIndex: "STT",
      key: "STT",
      className: "centerCell",
      width: 90,
    },
    {
      title: "Thời gian",
      dataIndex: "timeCreate",
      key: "timeCreate",
      className: "centerCell",
      ellipsis: { showTitle: false },
    },
    {
      title: "NV chủ động chat xuống",
      dataIndex: "agentMessageCount",
      key: "agentMessageCount",
      className: "centerCell",
      width: "15%",
      ellipsis: { showTitle: false },
    },
    {
      title: "KH đã đọc",
      dataIndex: "customerMessageReadNotRespondedCount",
      key: "customerMessageReadNotRespondedCount",
      className: "centerCell",
      ellipsis: { showTitle: false },
    },
    {
      title: "KH chưa đọc",
      dataIndex: "customerMessageUnreadCount",
      key: "customerMessageUnreadCount",
      className: "centerCell",
      ellipsis: { showTitle: false },
    },
    {
      title: "KH đã trả lời",
      dataIndex: "customerMessageRespondedCount",
      key: "customerMessageRespondedCount",
      className: "centerCell",
      ellipsis: { showTitle: false },
    },
  ];
  const tableLoading = {
    spinning: false,
    indicator: <IconSpin className="iconSpin" />,
  };
  return (
    <>
      <Row style={{ width: "100%" }}>
        <Table
          loading={tableLoading}
          className="TblProductStatistics"
          style={{ width: "100%", marginTop: "2.6rem" }}
          columns={
            type === "staffChatUp"
              ? columnsChatUp
              : type === "staffChatDown"
              ? columnsChatDown
              : type === "totalChat"
              ? columnTotalChat
              : []
          }
          dataSource={dataSourceChatUp}
          pagination={
            totalElements > 10
              ? {
                  onChange: (page) => {
                    setConfig((prev) => ({
                      ...prev,
                      page: page - 1,
                    }));
                  },
                  current: config.page + 1,
                  // current: config.option.offset,
                  // defaultCurrent: config.option.offset,
                  total: totalElements,
                  pageSize: 10,
                  prevIcon: <IconPre />,
                  nextIcon: <IconNext />,
                  showSizeChanger: false,
                }
              : false
          }
        />
      </Row>
    </>
  );
};

export default TableStatisticChat;

export const labelToKeyMap = {
  "NV chủ động chat xuống": "agentMessageCount",
  "KH chủ động chat lên": "customerMessageCount",
  "KH đã trả lời": "customerMessageRespondedCount",
  "KH đã đọc": "customerMessageReadNotRespondedCount",
  "KH chưa đọc": "customerMessageUnreadCount",
  "NV đã trả lời": "agentMessageRespondedCount",
  "NV đã đọc": "agentMessageReadNotRespondedCount",
  "NV chưa đọc": "agentMessageUnreadCount",
};
